import { useDispatch, useSelector } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import { useContext, useEffect, useState } from "react";
import { addDays, subDays, format, set, addMonths } from "date-fns";
import EventCalendar from "../../../../components/components/event-calendar/EventCalendar";
import { Sidebar } from "primereact/sidebar";
import ListAppointment from "./ListAppointment";
import { Button } from "primereact/button";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../../store/ui-context";
import { ConfirmDialog } from "primereact/confirmdialog";

const title = "Appointment - Web";

const thisMonthFirstDay = set(new Date(), { date: 1 });

const AppointmentWebPage = (props) => {
  const uiContext = useContext(UiContext);

  const dispatch = useDispatch();
  const [events, setEvents] = useState([]);
  const [visibleSideBar, setVisibleSideBar] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(thisMonthFirstDay);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const { requestPost, requestDelete, requestGetOne, loading, requestGet } =
    useAPIRequest();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
    handleChangeMonth(selectedMonth);
  }, []);

  const handleClickDate = (date) => {
    if (!visibleSideBar) setVisibleSideBar(true);
    setSelectedDate(date);
  };

  const convertScheduleCustomerToAppointment = (list) => {
    return list.map((item) => {
      return {
        date: new Date(item.transaction_date),
        title: item.data_customer
          ? item.data_customer.name
          : "*Not Registered*",
        data: item,
        animate: !item.confirmation_bc_date ? true : false,
        stale: !item.confirmation_bc_date ? true : false,
      };
    });
  };

  const handleChangeMonth = async (date) => {
    setEvents([]);
    setSelectedMonth(date);

    // get first date of month from date
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDayOfMonth.setHours(0, 0, 0, 0);
    const firstDayOfMonthString = format(
      firstDayOfMonth,
      "yyyy-MM-dd HH:mm:ss"
    );

    // to next month
    const lastDayOfMonth = new Date(
      date.getFullYear(),
      date.getMonth() + 1 + 1,
      0
    );
    lastDayOfMonth.setHours(23, 59, 59, 999);
    const lastDayOfMonthString = format(lastDayOfMonth, "yyyy-MM-dd HH:mm:ss");

    setSelectedMonth(firstDayOfMonth);

    return await requestGet({
      fullUrl: "api/masterdata/employee/get-schedule",
      params: {
        take: 10000,
        page: 1,
        order: "transaction_date",
        order_method: "ASC",
        filter: `transaction_date:>=:${firstDayOfMonthString};transaction_date:<=:${lastDayOfMonthString}`,
        with_customer: 1,
        with_bc: 1,
        with_therapist_1: 1,
        with_therapist_2: 1,
        with_therapist_3: 1,
        with_nurse_1: 1,
        with_nurse_2: 1,
        with_nurse_3: 1,
        with_doctor: 1,
        with_products: 1,
        with_crm_options: 1,
      },
      onSuccess: ({ data }) => {
        const newData = convertScheduleCustomerToAppointment(data);
        setEvents(newData);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const handleRefreshMonth = async () => {
    handleChangeMonth(selectedDate);
  };

  const getEventsByDate = (date) => {
    return events.filter(
      (event) => format(event.date, "yyyy-MM-dd") === format(date, "yyyy-MM-dd")
    );
  };

  return (
    <div className={`col-start-start px-4 gap-4 w-100`}>
      <ConfirmDialog />
      <Sidebar
        visible={visibleSideBar}
        position="right"
        onHide={() => setVisibleSideBar(false)}
        className="relative"
      >
        <div className="col-start-start gap-2 pt-1">
          <div className="row-start-center gap-1">
            <Button
              className="max-w-[2rem] max-h-[2rem]"
              icon="pi pi-refresh"
              rounded
              text
              onClick={handleRefreshMonth}
            />
            <span className="font-bold">
              {format(selectedDate, "dd MMMM yyyy").toUpperCase()}
            </span>
          </div>
          <ListAppointment
            events={getEventsByDate(selectedDate)}
          />
          <div className="h-[5rem]" />
        </div>
      </Sidebar>
      <div></div>
      <div className="elevated-card-tight-vertical row-start-center w-full gap-3">
        <EventCalendar
          loading={loading}
          events={events}
          selectedMonth={selectedMonth}
          onClick={handleClickDate}
          onChangeMonth={handleChangeMonth}
        />
      </div>
      <div></div>
    </div>
  );
};

export default AppointmentWebPage;
